<template>
  <section class="website-section content-wrapper" v-if="isLoaded">
    <app-header></app-header>
    <div class="contact-info-wrapper">
      <div class="contact-left-col">
        <div class="c-introduction">
          <header class="main-section-title">
            <h1>{{ $store.getters.settings.client.contact_page_title }}</h1>
          </header>
          <div class="body-text-wrapper">
            <div class="body-text body-text--large" v-if="$store.getters.settings.client.contact_page_body"
                 v-html="$store.getters.settings.client.contact_page_body"></div>
          </div>
        </div>

        <div class="contact-form">
          <form class="form-wrapper" v-on:submit.prevent="submit()">
            <fieldset>
              <legend class="legend-title">SYNTAX: {{ $store.getters.settings.appName }} brand guardians</legend>
              <p class="form-desc">
                Please contact SYNTAX for advice related to the brand guidelines.
              </p>
              <input class="form-input"
                     type="text"
                     placeholder="Name*"
                     @blur="$v.formData.name.$touch()"
                     :class="{'is-invalid':$v.formData.name.$error}"
                     v-model="formData.name">
              <input class="form-input"
                     type="email"
                     placeholder="Email*"
                     @blur="$v.formData.email.$touch()"
                     :class="{'is-invalid':$v.formData.email.$error}"
                     v-model="formData.email">
              <input class="form-input" type="text" placeholder="Subject" v-model="formData.subject">
              <textarea class="form-text-area" placeholder="Your message…" v-model="formData.message"></textarea>
              <div class="form-actions">
                <a class="t-text-color form-actions__link">*Mandatory field.</a>
                <div class="form-btns-group">
                  <button class="btn default-btn">Cancel</button>
                  <button class="btn t-bg-color">Send</button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="contact-right-col">
        <div class="contact-card" v-for="contact in contacts">
          <p class="contact-card__info" v-if="contact.name">{{ contact.name }}</p>
          <p class="contact-card__info" v-if="contact.title">{{ contact.title }}</p>
          <p class="contact-card__info t-text-color" v-if="contact.phone">{{ contact.phone }}</p>
          <p class="contact-card__info" v-if="contact.email">
            <a class="t-text-color" :href="'mailto:'+contact.email">
              {{ contact.email }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="popup submission" v-if="showModal">
      <div class="popup-info submission-info">
        <div class="submission-info__icon check"></div>
        <div class="popup-info__message">
          Thank you!
          <br>
          Your submission will be reviewed
        </div>
        <button class="popup-btn btn t-bg-color" @click="showModal = false">Done</button>
      </div>
    </div>
  </section>
</template>
<script>
  import { required, email } from 'vuelidate/lib/validators'
  import appHeader from '../layout/Header.vue'

  export default {
    components: {
      appHeader
    },
    data () {
      return {
        showModal: false,
        isLoaded: false,
        contacts: {},
        formData: {
          name: '',
          email: '',
          subject: '',
          message: ''
        }
      }
    },
    validations: {
      formData: {
        name: {
          required
        },
        email: {
          required,
          email
        }
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          let qs = require('qs')
          this.axios.post('/contacts/submit', qs.stringify(this.formData))
            .then(response => {
              if (response.data.success === 'success') {
                this.showModal = true
                this.formData = {
                  name: '',
                  email: '',
                  subject: '',
                  message: ''
                }
                this.$v.$touch()
                this.$v.$reset()
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      getData () {
        this.$store.dispatch('setIsLoaded', false)
        this.isLoaded = false
        this.axios.get('/contacts')
          .then(response => {
            this.contacts = response.data.contacts
            this.$store.dispatch('setIsLoaded', true)
            this.isLoaded = true
            document.title = 'Contact Information ' + ' - ' + this.$store.getters.settings.appName
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    created () {
      this.getData()
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue